// src/services/testAliadosApi.js
// Cliente para el módulo de aliados de prueba (solo SuperAdmin).

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5246';

function tok() { return localStorage.getItem('ecolab_token') || null; }

async function apiGet(path) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { Authorization: `Bearer ${tok()}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `GET ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

async function apiSend(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tok()}` },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `${method} ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

export const getRangoAliadosTest    = () => apiGet('/api/ecolab/admin/test-aliados/rango');
export const listarTestAliados      = () => apiGet('/api/ecolab/admin/test-aliados');
export const crearBatchAliadosTest  = (dto) => apiSend('POST', '/api/ecolab/admin/test-aliados/crear-batch', dto);
export const limpiarTodoAliadosTest = () => apiSend('DELETE', '/api/ecolab/admin/test-aliados/limpiar-todo');

// Constantes NIT test (deben coincidir con TestData.cs del backend)
export const TEST_NIT_RANGO_INICIO = 999000000;
export const TEST_NIT_RANGO_FIN    = 999000099;

export function esNitTest(nit) {
  if (!nit) return false;
  // Los NITs pueden venir con dígito de verificación tipo "999000001-2"
  const t = String(nit).trim();
  const idxGuion = t.indexOf('-');
  const bloque = idxGuion > 0 ? t.substring(0, idxGuion) : t;
  const n = parseInt(bloque, 10);
  if (Number.isNaN(n)) return false;
  return n >= TEST_NIT_RANGO_INICIO && n <= TEST_NIT_RANGO_FIN;
}
